module.exports = __webpack_public_path__ + "assets/ic_tree16.336fc0a8.svg";